import { BaseErrorHandler } from '@app/@graphql';
import { ErrorResponse } from '@apollo/client/link/error';
import { NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { HttpErrorResponse } from '@angular/common/http';

export class ApiErrorHandler extends BaseErrorHandler {
  constructor(private translate: TranslateService, private toastr: NbToastrService) {
    super();
  }

  handleError({ graphQLErrors, networkError, response }: ErrorResponse) {
    if (Array.isArray(graphQLErrors) ) {
        (<any[]>graphQLErrors).map(err => {
          if (err.extensions && err.extensions.code) {
            this.toastr.danger(this.translate.instant(marker(err.error || err.extensions?.code)), this.translate.instant(marker('request_error_title')), {
              duration: this.duration,
              preventDuplicates: true
            });
          }
        });
    }
  }
}
